import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Cookies from 'universal-cookie';

export default function(ComposedComponent) {
  class RequireAuth extends Component {
    static contextTypes = {
      router: PropTypes.object
    };

    static state = {
      notAuthed: false
    };

    redirect(to) {
      global.window && window.location && window.location.replace(to + window.location.search);
    }

    redirectToLogin() {
      if (global.window && window.location) {
        const cookies = new Cookies();
        cookies.set('redirectTo', window.location.pathname, {
          path: '/',
          maxAge: 60
        });
        window.location.replace('/login' + window.location.search);
      }
    }

    render() {
      if (!this.props.authenticated) {
        this.redirectToLogin();
        return null;
      }

      if (this.props.user.requestedAccount && this.props.user.requestedAccount === this.props.user.selectedAccount) {
        this.redirect(this.props.user.isSso ? '/awaiting/sso' : '/awaiting');
        return null;
      }

      return <ComposedComponent {...this.props} />;
    }
  }

  function mapStateToProps(state) {
    return {
      authenticated: state.auth.authenticated,
      user: state.auth.user
    };
  }

  return connect(mapStateToProps)(RequireAuth);
}
